/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.layouts.controllers', [])

.controller('LayoutsController', ['$scope', function($scope) {

    $scope.layouts = {

      model: "Your spankin new application.layouts.default view!",

      init: function() {},

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      }

    };

    $scope.layouts.init();

}]);